.g6{border:1px solid #ddd;}